import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.0471 1.37012L18.8705 1.9376C20.0768 2.76906 21.1233 3.81549 21.9548 5.02184L22.5223 5.8452L20.8756 6.98024L20.3081 6.15688C19.6146 5.15081 18.7416 4.27779 17.7355 3.58437L16.9121 3.01688L18.0471 1.37012Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.7523 4.46212C13.2151 3.92523 12.3441 3.92651 11.8086 4.46497L6.55473 9.74721L6.99913 8.65149C7.55869 7.27181 5.99352 6.00154 4.75852 6.83306C4.57016 6.95988 4.41285 7.12759 4.29834 7.32369L1.91873 11.3985C0.271144 14.2198 0.733135 17.7974 3.04341 20.1077L3.88772 20.952C6.69539 23.7597 11.2475 23.7597 14.0552 20.952L19.0896 15.9164C19.6263 15.3796 19.6265 14.5094 19.09 13.9724C18.5531 13.4349 17.6821 13.4347 17.1449 13.9719L15.5413 15.5755L15.0103 15.0444L18.7004 11.3543C19.2372 10.8174 19.2372 9.94702 18.7004 9.41014C18.1635 8.87324 17.2931 8.87323 16.7562 9.41011L13.0661 13.1002L12.5357 12.5699L17.5926 7.51303C18.1294 6.97621 18.1296 6.1059 17.593 5.56887C17.0561 5.03154 16.1852 5.03137 15.6481 5.56849L10.5912 10.6253L10.061 10.0952L13.7525 6.40366C14.2887 5.86749 14.2886 4.99816 13.7523 4.46212Z"}}]};

const WaveRightFilled = Vue.extend<IconProps>({
  name: 'WaveRightFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'wave-right-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default WaveRightFilled;
